import React, { useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { useKeycloak } from '../services/KeycloakProvider';
import { useTranslation } from 'react-i18next';

export const NavMenu = () => {
  const { t } = useTranslation('localizable');
  const [collapsed, setCollapsed] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { keycloak, authenticated, userInfo } = useKeycloak();

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleDropdownKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setDropdownOpen(!dropdownOpen);
    } else if (e.key === 'Escape') {
      if (dropdownOpen) {
        setDropdownOpen(false);
      }
    }
  };

  const handleLogout = () => {
    const options = {
      redirectUri: window.location.origin
    };
    keycloak.logout(options);
  };

  return (
    <header>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light role="navigation" aria-label={t('Primary navigation')}>
        <NavbarBrand tag={Link} to="/">
          <img alt="Bridge2AI logo" src="/assets/images/logo.svg" height="30em" style={{ marginRight: '10px' }} />
          </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" aria-label={t('Toggle navigation')} aria-expanded={!collapsed} />
        {authenticated ? (
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle
                  nav
                  caret
                  aria-haspopup={true}
                  aria-expanded={dropdownOpen}
                  aria-controls="user-menu"
                  onKeyDown={handleDropdownKeyDown}
                >
                  {userInfo?.given_name} {userInfo?.family_name}
                </DropdownToggle>
                <DropdownMenu end id="user-menu" role="menu" aria-label={t('User menu')}>
                  <DropdownItem role="menuitem" onClick={handleLogout}>{t('Logout')}</DropdownItem>
                </DropdownMenu>
              </Dropdown>

            </ul>
          </Collapse>
        ) : (
          null
        )}
      </Navbar>
    </header>
  );
};
